import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";
import {OrderM} from "../model/order.mobel";
import {PaymentM} from "../model/payment";
import {OrderDetailM} from "../model/order_detail.model";
import {Util} from "../util/util";

@Injectable()
export class RefundService {
  private order: OrderM = new OrderM();
  private payment: PaymentM = new PaymentM();

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getAll(searchStr: string, status: string, buyer_id: number = 0, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    return this.http.get(`/api/refund/list?searchStr=${searchStr}&status=${status}&buyer_id=${buyer_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json());
  }

  getDetail(bill_no: string) {
    this.reloadToken()
    return this.http.get(`/api/refund/detail/${bill_no}`, this.options).map(res => res.json());
  }

  getBillingInfo(bill_no: string) {
    this.reloadToken()
    return this.http.get(`/api/refund/billing/${bill_no}`, this.options).map(res => res.json());
  }

  addRefund(refund) {
    this.reloadToken()
    return this.http.post(`/api/refund`, refund, this.options).map(res => res.json());
  }

  updateRefund(refund) {
    this.reloadToken()
    return this.http.put(`/api/refund/${refund.bill_no}`, refund, this.options).map(res => res.json());
  }

  updateStatus(bill_no: string, status: string) {
    this.reloadToken()
    return this.http.put(`/api/refund/status/${bill_no}/${status}`, {}, this.options).map(res => res.json());
  }

  returnProduct(refund_detail_id:number){
    this.reloadToken()
    return this.http.post(`/api/refund/returnProduct/${refund_detail_id}`, {}, this.options).map(res => res.json())
  }

  getCartList() {
    ////console.log('getCartList');
    this.reloadToken()
    return this.http.get(`/api/cart/getList`, this.options).map(res => res.json());
  }

  addOrder(payment: PaymentM) {
    this.reloadToken()
    return this.http.post(`/api/order/add/`, payment, this.options).map(res => res.json());
  }

  closeClassWithRating(orderD: OrderDetailM) {

    this.reloadToken()
    return this.http.put(`/api/order/detail/rateLearning`, orderD, this.options).map(res => res.json());
  }

  getAllOrders(searchStr: string, status: string, offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/order/getListByAdmin?searchStr=${searchStr}&status=${status}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }

  getAllPendingOrdersOfUser(user_id: number, status: string, offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/order/getListByAdmin?user_id=${user_id}&status=${status}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }


  getOrderStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/order/getStatusCount`, this.options).map(res => res.json());
  }


  updateSkypeLink(orderD: OrderDetailM) {
    this.reloadToken()
    return this.http.put(`/api/classroom/saveSkypeLink`, orderD, this.options).map(res => res.json());
  }

  getPayment(searchStr: string, status: string, startDate: string, endDate: string, offset = 0, limit = 30) {
    this.reloadToken()
    return this.http.get(`/api/payment/getList?searchStr=${searchStr}&status=${status}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}`, this.options).map(res => res.json());
  }


  approvePayment(payment: PaymentM) {
    this.reloadToken()
    return this.http.put(`/api/payment/approve`, payment, this.options).map(res => res.json());
  }

  create(payment: PaymentM) {
    this.reloadToken()
    return this.http.post(`/api/payment`, payment, this.options).map(res => res.json());
  }

  createAndApprove(payment: PaymentM) {
    this.reloadToken()
    return this.http.post(`/api/payment/addAndApprove`, payment, this.options).map(res => res.json());
  }

  savePayment(payment: PaymentM) {
    this.reloadToken()
    return this.http.put(`/api/payment/update`, payment, this.options).map(res => res.json());
  }

  deletePayment(id: number) {
    this.reloadToken()
    return this.http.delete(`/api/payment/${id}`, this.options).map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/refund.service.ts